import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { GuideModal } from './GuideModal';
const links = [{
  label: 'Ablauf der Academy',
  to: '/ablauf'
}, {
  label: 'About Me',
  to: '/about-me'
}];
export function Navbar() {
  const [guideOpen, setGuideOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="relative z-50 w-full" data-id="element-317" data-mp="4koqfa9z9l6n">
      <nav aria-label="Hauptnavigation" className="gold-shimmer w-full border-b border-gold/40 bg-cream px-4 py-2 sm:px-6" data-id="element-318" data-mp="4lhyqfol4iqw">
        <div className="mx-auto flex w-full max-w-[1300px] items-center justify-between gap-4" data-id="element-319" data-mp="ejxghs1q2fnq">
          <div className="flex flex-1 items-center justify-start" data-id="element-320" data-mp="9jrwmy1p1xg7">
            <Link to="/" className="shrink-0" aria-label="Zur Startseite" data-id="element-321" data-mp="9mnukmdjkm4n">
              <img src="https://cdn.magicpatterns.com/uploads/dVxge7E5WrZsG2Xk4nm9RJ/image.png" alt="Logo der Sales Academy" className="h-9 w-9 rounded-full object-contain md:h-10 md:w-10" data-id="element-322" data-mp="1pwzx2n3tn57w" />
            </Link>
          </div>

          <ul className="hidden items-center justify-center gap-6 md:flex lg:gap-8" data-id="element-323" data-mp="em9ambh9yxtl">
            {links.map(link => <li key={link.to} data-id="element-324" data-mp="jnf8sotpfdai">
                <Link to={link.to} className="whitespace-nowrap text-sm font-semibold text-neutral-900 transition-colors hover:text-gold" data-id="element-325" data-mp="olgmsvc9wmf4">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="flex flex-1 items-center justify-end" data-id="element-326" data-mp="w5snwpfhq9y">
            <button type="button" onClick={() => setGuideOpen(true)} className="btn-gold-shiny hidden rounded-full px-6 py-2.5 text-sm font-semibold md:inline-block" data-id="element-327" data-mp="uutka6xh6p6">
              Kostenloses Gespräch buchen
            </button>

            <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label={menuOpen ? 'Menü schließen' : 'Menü öffnen'} className="flex h-10 w-10 items-center justify-center rounded-full text-neutral-900 transition-colors hover:bg-neutral-100 md:hidden" data-id="element-328" data-mp="39aegyskx3uwb">
              {menuOpen ? <XIcon className="h-6 w-6" data-id="element-329" data-mp="364cfu2cu357m" /> : <MenuIcon className="h-6 w-6" data-id="element-330" data-mp="2ibvy5sx0df8u" />}
            </button>
          </div>
        </div>
      </nav>

      {menuOpen && <div id="mobile-menu" className="w-full border-b border-gold/40 bg-cream px-4 pb-4 pt-2 shadow-lg md:hidden" data-id="element-331" data-mp="2devoz94v3wdi">
          <ul className="flex flex-col" data-id="element-332" data-mp="2nbic64knuzip">
            {links.map(link => <li key={link.to} data-id="element-333" data-mp="2ndl62zoxpcsp">
                <Link to={link.to} onClick={() => setMenuOpen(false)} className="block border-b border-neutral-100 py-3 text-sm font-semibold text-neutral-900 transition-colors hover:text-gold" data-id="element-334" data-mp="7juo6ynmkhc1">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <button type="button" onClick={() => {
        setMenuOpen(false);
        setGuideOpen(true);
      }} className="btn-gold-shiny mt-4 w-full rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-335" data-mp="f1isw9g3rgpi">
            Kostenloses Gespräch buchen
          </button>
        </div>}

      <GuideModal open={guideOpen} onClose={() => setGuideOpen(false)} data-id="element-336" data-mp="xumq24sj4bov" />
    </header>;
}